import styled_components from "styled-components";
import { Box } from "pcln-design-system";
const LoadMoreContainer = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "LoadMore.styles__LoadMoreContainer"
})([
    "height:455px;border:1px dotted rgba(224,229,234,1);border-radius:16px;width:166px;"
]);
const LinkContainer = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "LoadMore.styles__LinkContainer"
})([
    "cursor:pointer;"
]);
export { LinkContainer, LoadMoreContainer };
